module.exports = __webpack_public_path__ + "toBride1-we-g-n.7fb99126.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-g-n.jpg
// module id = 6uZ5
// module chunks = 0